import type { FaireThemeEntity } from "../../entity_types/theme";

export const retro_modern_statements: FaireThemeEntity = {
  token: "retro-modern-statements",
  type: "theme",
  name: "Retro-Modern Statements",
  description: "Capture a unique charm with bold accessories featuring protective motifs and classic timepiece designs that stand out on any display.",
  teaser: "K&K Visage Beauty Lounge has a predicted store type of clothing and a brick-and-mortar presence, making these distinctive statement pieces perfect for visual merchandising and attracting walk-in interest.",
  detail: "The recent cart contains several items with vintage and symbolic themes, such as the Evil Eye statement ring and the Vintage Gold Oval Bracelet Watch.",
  bgColor: "#F5E6CC",
  tileBgColor: "#6b4a3d",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_uctnb2jqtq",
    "p_tpf2apke3k",
    "p_xe3chm3d2e",
    "p_nb2e63pmmx",
    "p_3pcekmbkc4",
    "p_8jqk33qjaz",
    "p_63en8h4gdu",
    "p_5e4mgthvp6",
    "p_ykwagh58xx",
    "p_3aq8cn53et",
    "p_duh7pwrdqj",
    "p_r64meptvta",
    "p_zq6tmtyza7",
    "p_t4qjmtqa5p",
    "p_ut7ncasez6",
    "p_4tat7nvaph",
    "p_tz28rdt33u",
    "p_p6rp8pe965",
    "p_ykcapkuvqq",
    "p_bwvg3e5445",
    "p_zt92rzmb6v",
    "p_embu9wurwd",
    "p_vfj4xvgqfe",
    "p_6v7dxsr9e6",
    "p_f8tptzemr3",
    "p_vrsqsbtkmm",
    "p_hp4fadhsup",
    "p_3b5tmupxdg",
    "p_5npwd9k9wg",
    "p_esqrwdngp5",
    "p_yquv9gpjrp",
    "p_4y4jh6jdvs",
    "p_5r5pw65mve",
    "p_sqe8wwg25b",
    "p_qwgp4bjyhx",
    "p_ut3tbs6mrw",
    "p_x6jnvaenpu",
    "p_zxurf3jtrh",
    "p_m8a3syb77h",
    "p_g7jzm6sy9w",
    "p_ujyrwsn6w8",
    "p_jhcrb92fnq",
    "p_5tf3mnhbng",
    "p_k9u8p5rx75",
    "p_t6yjezsw5d",
    "p_ffm733ehvy",
    "p_m8ybpjvqmq",
    "p_r3jb7xvdwb",
    "p_ufjavmwa64",
    "p_zmtpk6urpp",
    "p_wwm4rr2xgb",
    "p_vjq7z5y2su",
    "p_muuvzhcqeb",
    "p_eh2vb55544",
    "p_dtubmvrs4w",
    "p_pdr6j73eqe",
    "p_35vp744t8l",
    "p_3d86pb9zxf",
    "p_fmp59xpqza",
    "p_fndrqytean",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
